export default __webpack_public_path__ + "media/images/email-f3777edf41ac47a45f3e9aee90ad01a5.svg";